// Shared HTTP client for the middleware API.
//
// This is the single axios instance the whole app talks to the middleware
// with. It is intentionally free of store imports so any module (feature
// api layers, composables, store modules) can use it without pulling in
// Vuex. The auth store module owns everything session-related on it:
//   - default headers (token / domain / uname) set on login & session restore
//   - the 401 auto-logout response interceptor
//
// New code should import { middleware } from "@/services/http" instead of
// reaching into store/modules/auth/actions.js.
import axios from "axios";
import config from "../../public/config.json";

export const middleware = axios.create({
  baseURL: config.middlewareURL,
  headers: {
    "Content-Type": "application/json",
  },
});
